module.exports = __webpack_public_path__ + "static/media/emojis_02.f0f200cc.svg";